import {Typography} from '@ttx/design-system';
import {capitalize} from '@ttx/design-system/src/nft-details-panel/utils';
import React from 'react';
import {WalletNetwork} from '../../../contexts/authentication-context/types';
import {BasicTitleButtonModal} from './basic-title-button-modal';

export interface WrongNetworkModalProps {
  onClose: () => void;
  onPressButton: () => void;
  network?: WalletNetwork;
}

export const WrongNetworkModal: React.FC<WrongNetworkModalProps> = ({
  onClose,
  onPressButton,
  network,
}) => {
  return (
    <BasicTitleButtonModal
      title="Wrong network"
      onClose={onClose}
      buttonType="secondary"
      onPressButton={onPressButton}
      buttonCta={`Switch to ${capitalize(network || '')}`}
    >
      <Typography textStyle="s" color="textDefault">
        To complete your purchase, please connect to the{' '}
        {network ? capitalize(network) : 'NFTs'} network
      </Typography>
    </BasicTitleButtonModal>
  );
};
